import PropTypes from 'prop-types';
import React from 'react';
import { FormattedMessage } from 'react-intl';

import classNames from 'classnames';

import {outcomes, UNKNOWN} from '~/features/updateEvents/constants/outcomes';
import OverlayTrigger from '@rio-cloud/rio-uikit/lib/es/OverlayTrigger';
import Tooltip from '@rio-cloud/rio-uikit/lib/es/Tooltip';

export const UpdateEventOutcome = ({ value }) => {
    const outcome = outcomes[value] || outcomes[UNKNOWN];

    return (
        <OverlayTrigger placement='top' overlay={
            <Tooltip id='tooltip' className='top-right'>
                <FormattedMessage id={outcome.tooltip} />
            </Tooltip>}>
            <span className={classNames('label label-condensed', outcome.className)}>
                <FormattedMessage id={outcome.label} />
            </span>
        </OverlayTrigger>
    );
};

export default UpdateEventOutcome;

UpdateEventOutcome.propTypes = {
    // props
    value: PropTypes.string,
};
